import React, { useEffect, useRef } from "react";
import "./App.css";
import { Routes, Route, Outlet, useLocation } from "react-router";
import { Modal, ModalRef } from "./components/modal/modal";
import { Home } from "./pages/Home";
import LandingRouter from "./pages/LandingRouter";
import ScrollToTopButton from "./components/scrollToTop/ScrollToTop";
import { AuthRoute } from "./shared/auth/AuthRoute";
import { Role } from "./shared/enums/Role";
import axios from "axios";
import { ToasterComponent } from "./components/toaster/toaster";
import ExternalApplicationEvidence from "./pages/external/ExternalApplicationEvidence";
import ExternalApplicationRequest from "./pages/external/ExternalApplicationRequest";
import ApplicationsList from "./pages/appllicationPages/admin/ApplicationsList";
import ApplicationView from "./pages/appllicationPages/ApplicationView";
import { Footer } from "./components/footer/Footer";
import { LoginPage } from "./pages/Login";
import LogoutPage from "./pages/Logout";
import ApplicationFilesPage from "./pages/appllicationPages/ApplicationFilesPage";
import ChildPageLegacy from "./pages/appllicationPages/legacy/ChildPageLegacy";
import ApplicationTypePage from "./pages/appllicationPages/ApplicationTypePage";
import { SpinnerComponent } from "./components/spinner/SpinnerComponent";
import AdminNotesPage from "./pages/appllicationPages/AdministrativeNotesPage";
import AssignAssessorPage from "./pages/appllicationPages/AssignAssessorPage";
import { ApplicationContextProvider } from "./components/applicationComponents/context/applicationContext";
import MyApplicationsList from "./pages/appllicationPages/admin/MyApplicationsList";
import ManageUsers from "./pages/useManagment/ManageUsers";
import EditUser from "./pages/useManagment/EditUser";
import ReferenceDataManagement from "./pages/ReferenceDataManagement";
import AssignStatusPage from "./pages/appllicationPages/AssignStatusPage";
import ApplicationChecklistPage from "./pages/appllicationPages/ApplicationChecklistPage";
import AppealRequestPage from "./pages/appllicationPages/AppealRequestPage";
import ContextOfChildPage from "./pages/appllicationPages/ContextOfChildPage";
import SupportTypePage from "./pages/appllicationPages/SupportTypePage";
import { SideNav } from "./components/sideNav/SideNav";
import { Header } from "./components/header/Header";
import AppealOutcomePage from "./pages/appllicationPages/AppealOutcomePage";
import ProviderList from "./pages/providerPages/ProviderList";
import ProviderDetailsPage from "./pages/providerPages/ProviderDetailsPage";
import { ProviderComponentContext } from "./components/providerComponents/context/providerContext";
import ProviderView from "./pages/providerPages/ProviderView";
import ApplicationProviderViewLegacy from "./pages/appllicationPages/provider/ApplicationProviderViewLegacy";
import ApplicationsProviderList from "./pages/appllicationPages/provider/ApplicationsProviderList";
import AssessmentsList from "./pages/appllicationPages/admin/AssessmentsList";
import FinalisedList from "./pages/appllicationPages/admin/FinalisedList";
import ApplicationViewLegacy from "./pages/appllicationPages/legacy/ApplicationViewLegacy";
import ManageUserPage from "./pages/providerPages/ManageUserPage";

import SupportRequestedPage from "./pages/appllicationPages/SupportRequestedPage";
import GroupInformationPage from "./pages/appllicationPages/GroupInformationPage";
import ChildPage from "./pages/appllicationPages/ChildPage";
import ProvidingInclusiveKindergartenEnvironmentPage from "./pages/appllicationPages/ProvidingInclusiveKindergartenEnvironmentPage";
import GroupSupportNeedsPage from "./pages/appllicationPages/legacy/GroupSupportNeedsPage";
import KindergartenPageLegacy from "./pages/appllicationPages/legacy/KindergartenPageLegacy";
import KindergartenPage from "./pages/appllicationPages/KindergartenPage";
import ChildAttendancePage from "./pages/appllicationPages/ChildAttendancePage";
import ResourcesLinksPage from "./pages/Resources";
import KindergartenApplicationView from "./pages/appllicationPages/kindergartenUsers/kindergartenApplicationView";
import KinderProgramPage from "./pages/appllicationPages/kinderProgramPage";
import ApplicationProviderView from "./pages/appllicationPages/provider/ApplicationProviderView";
import KindergartenScreeningPage from "./pages/appllicationPages/KindergartenScreeningPage";
import ScreeningQuestionsPage from "./pages/appllicationPages/ScreeningQuestionsPage";
import SubmitInitialApplicationPage from "./pages/appllicationPages/SubmitApplicationPage";
import SupportTypePageLegacy from "./pages/appllicationPages/legacy/SupportTypePageLegacy";
import ApplicationApprovalPageLegacy from "./pages/appllicationPages/legacy/ApplicationApprovalPageLegacy";
import ContextOfChildPageLegacy from "./pages/appllicationPages/legacy/ContextOfChildPageLegacy";
import AuthorisedRepresentativeComponent from "./components/applicationComponents/authorisedRepresentative/AuthorisedRepresentativeComponent";
import SupportingDocumentsPage from "./pages/appllicationPages/SupportingDocumentsPage";
import CreateLegacyApplication from "./pages/appllicationPages/legacy/CreateLegacyApplication";
import ContextOfChildComponentLegacy from "./components/applicationComponents/legacy/contextOfChild/ContextOfChildComponentLegacy";
import KindergartenApplicationsListSubmitted from "./pages/appllicationPages/kindergartenUsers/KindergartenApplicationListSubmitted";
import KindergartenApplicationsListPending from "./pages/appllicationPages/kindergartenUsers/KindergartenApplicationListPending";
import PresubmissionList from "./pages/appllicationPages/admin/PresubmissionList";
import ApplicationTypePageLegacy from "./pages/appllicationPages/legacy/ApplicationTypePageLegacy";
import ApplicationTypeComponent from "./components/applicationComponents/applicationType/ApplicationTypeComponent";
import ApplicationChecklistPageLegacy from "./pages/appllicationPages/legacy/ApplicationChecklistPageLegacy";
import ApplicationCreationPage from "./pages/appllicationPages/ApplicationCreationPage";
import DepartmentApplicationList from "./pages/appllicationPages/department/DepartmentApplicationList";
import DepartmentApplicationView from "./pages/appllicationPages/department/DepartmentApplicationView";
import AppealOutcomePageLegacy from "./pages/appllicationPages/legacy/AppealOutcomePageLegacy";
import AppealRequestPageLegacy from "./pages/appllicationPages/legacy/AppealRequestPageLegacy";
import TransferRequestPage from "./pages/appllicationPages/TransferRequestPage";
import DepartmentView from "./pages/departmentPages/DepartmentView";
import ManageDepartmentUserPage from "./pages/departmentPages/ManageDepartmentUserPage";
import ApplicationsAllList from "./pages/appllicationPages/admin/ApplicationsAllList";

function App() {
  axios.defaults.headers.post["Content-Type"] = "application/json";
  const modalRef = useRef<ModalRef>(null);

  const location = useLocation();

  useEffect(() => {
    document.documentElement.scrollTo({
      top: -100, // neg 100 because the main site nav pushes down some reason and 0 isnt enough
      left: 0,
      behavior: "instant",
    });
  }, [location.pathname]);

  return (
    <>
      <Modal cancelAction={() => console.log("closing")} confirmAction={() => console.log("confirm")} ref={modalRef} />
      <div className="app-container">
        <Routes>
          <Route
            element={
              <>
                <Outlet />
              </>
            }>
            <Route path="/*" element={<LandingRouter />} />
            <Route path="login" element={<LoginPage />} />
            <Route path="logout" element={<LogoutPage />} />
            <Route
              path="home"
              element={
                <AuthRoute roles={[Role.assessor, Role.manager, Role.root, Role.provider, Role.kindergarten, Role.department]}>
                  <>
                    <Header /> <Home />
                  </>
                </AuthRoute>
              }
            />
            <Route
              path="referencedatamanagement"
              element={
                <AuthRoute roles={[Role.manager, Role.root]}>
                  <>
                    <Header />
                    <ReferenceDataManagement />
                  </>
                </AuthRoute>
              }
            />
            <Route
              path="providers"
              element={
                <AuthRoute roles={[Role.assessor, Role.manager, Role.root, Role.provider]}>
                  <>
                    <Header />
                    <Outlet />
                  </>
                </AuthRoute>
              }>
              <Route index element={<ProviderList />} />
              <Route
                path=":id"
                element={
                  <ProviderComponentContext>
                    <Outlet />
                  </ProviderComponentContext>
                }>
                {providerChildren}
              </Route>
            </Route>
            <Route
              path="departmentUsers"
              element={
                <AuthRoute roles={[Role.assessor, Role.manager, Role.root]}>
                  <>
                    <Header />
                    <Outlet />
                  </>
                </AuthRoute>
              }>
              <Route index element={<DepartmentView />} />
              <Route path=":id" element={<ManageDepartmentUserPage />} />
            </Route>
            <Route path="ApplicationBaseLegacy/createApplication" element={<CreateLegacyApplication />} />,
            <Route
              path="allApplications"
              element={
                <AuthRoute roles={[Role.assessor, Role.manager, Role.root]}>
                  <>
                    <Header /> <Outlet />
                  </>
                </AuthRoute>
              }>
              <Route index element={<ApplicationsAllList />} />
              {internalCurrentLegacyApplications}
            </Route>
            <Route
              path="applications"
              element={
                <AuthRoute roles={[Role.assessor, Role.manager, Role.root]}>
                  <>
                    <Header /> <Outlet />
                  </>
                </AuthRoute>
              }>
              <Route index element={<ApplicationsList />} />
              {internalCurrentLegacyApplications}
            </Route>
            <Route
              path="presubmission"
              element={
                <AuthRoute roles={[Role.assessor, Role.manager, Role.root]}>
                  <>
                    <Header /> <Outlet />
                  </>
                </AuthRoute>
              }>
              <Route index element={<PresubmissionList />} />
              {applicationRoute(applicationCurrentChildren)}
            </Route>
            <Route
              path="assessments"
              element={
                <AuthRoute roles={[Role.assessor, Role.manager, Role.root]}>
                  <>
                    <Header /> <Outlet />
                  </>
                </AuthRoute>
              }>
              <Route index element={<AssessmentsList />} />
              {internalCurrentLegacyApplications}
            </Route>
            <Route
              path="myapplications"
              element={
                <AuthRoute roles={[Role.assessor, Role.manager, Role.root]}>
                  <>
                    <Header /> <Outlet />
                  </>
                </AuthRoute>
              }>
              <Route index element={<MyApplicationsList />} />
              {internalCurrentLegacyApplications}
            </Route>
            <Route
              path="finalised"
              element={
                <AuthRoute roles={[Role.assessor, Role.manager, Role.root]}>
                  <>
                    <Header /> <Outlet />
                  </>
                </AuthRoute>
              }>
              <Route index element={<FinalisedList />} />
              {internalCurrentLegacyApplications}
            </Route>
            <Route
              path="provider/applications"
              element={
                <AuthRoute roles={[Role.root, Role.provider]}>
                  <>
                    <Header />
                    <Outlet />
                  </>
                </AuthRoute>
              }>
              <Route index element={<ApplicationsProviderList />} />
              <Route
                path=":id"
                element={
                  <div className="p-0 h-auto flex">
                    <SideNav />
                    <ApplicationContextProvider>
                      <Outlet />
                    </ApplicationContextProvider>
                  </div>
                }></Route>
              {providerApplication}
            </Route>
            <Route
              path="kindergarten/pendingApplications"
              element={
                <AuthRoute roles={[Role.root, Role.kindergarten]}>
                  <>
                    <Header />
                    <Outlet />
                  </>
                </AuthRoute>
              }>
              <Route index element={<KindergartenApplicationsListPending />} />
              <Route
                path=":id"
                element={
                  <div className="p-0 h-auto flex">
                    <SideNav />
                    <ApplicationContextProvider>
                      <Outlet />
                    </ApplicationContextProvider>
                  </div>
                }>
                {kindergartenApplicationChildren}
              </Route>
            </Route>
            <Route
              path="kindergarten/submittedApplications"
              element={
                <AuthRoute roles={[Role.root, Role.kindergarten]}>
                  <>
                    <Header />
                    <Outlet />
                  </>
                </AuthRoute>
              }>
              <Route index element={<KindergartenApplicationsListSubmitted />} />
              <Route
                path=":id"
                element={
                  <div className="p-0 h-auto flex">
                    <SideNav />
                    <ApplicationContextProvider>
                      <Outlet />
                    </ApplicationContextProvider>
                  </div>
                }>
                {kindergartenApplicationChildren}
              </Route>
            </Route>
            <Route
              path="kindergarten/screening"
              element={
                <AuthRoute roles={[Role.root, Role.kindergarten, Role.manager]}>
                  <KindergartenScreeningPage />
                </AuthRoute>
              }></Route>
            <Route
              path="department/applications"
              element={
                <AuthRoute roles={[Role.department]}>
                  <>
                    <Header />
                    <Outlet />
                  </>
                </AuthRoute>
              }>
              <Route index element={<DepartmentApplicationList />} />
              <Route
                path=":id"
                element={
                  <div className="p-0 h-auto flex">
                    <SideNav />
                    <ApplicationContextProvider>
                      <Outlet />
                    </ApplicationContextProvider>
                  </div>
                }>
                <Route index element={<DepartmentApplicationView />} />
                <Route key="manageUsers" path=":userid" element={<ManageUserPage type="Kindergarten" />} />,
              </Route>
            </Route>
            <Route
              path="manageUsers"
              element={
                <AuthRoute roles={[Role.manager, Role.root]}>
                  <Outlet />
                </AuthRoute>
              }>
              <Route index element={<ManageUsers />} />
              <Route path="new" element={<EditUser />} />
              <Route path=":id" element={<EditUser />} />
            </Route>
            <Route path="applicationevidence" element={<ExternalApplicationEvidence />} />
            <Route
              path="externalRequest"
              element={
                <AuthRoute roles={[Role.manager, Role.root, Role.assessor]}>
                  <ExternalApplicationRequest />
                </AuthRoute>
              }
            />
          </Route>{" "}
          <Route
            path="resources"
            element={
              <>
                <ResourcesLinksPage />
              </>
            }
          />
        </Routes>
        <Footer />
        <ToasterComponent />
        <SpinnerComponent />
      </div>
      <ScrollToTopButton />
    </>
  );
}

const applicationCurrentChildren: React.ReactElement[] = [
  <Route key="1" index element={<ApplicationView />} />,
  <Route key="screeningQuestions" path="screeningQuestions" element={<ScreeningQuestionsPage />} />,
  <Route key="15" path="supportRequested" element={<SupportRequestedPage />} />,
  <Route key="7" path="kindergarten" element={<KindergartenPage />} />,
  <Route key="16" path="groupInformation" element={<GroupInformationPage />} />,
  <Route
    key="providingInclusiveKindergartenEnvironment"
    path="providingInclusiveKindergartenEnvironment"
    element={<ProvidingInclusiveKindergartenEnvironmentPage />}
  />,
  <Route key="3" path="child" element={<ChildPage />} />,
  <Route key="childAttendance" path="childAttendance" element={<ChildAttendancePage />} />,
  <Route key="supportingDocuments" path="supportingDocuments" element={<SupportingDocumentsPage />} />,
  <Route key="submitapplication" path="submitapplication" element={<SubmitInitialApplicationPage />} />,
  <Route key="14" path="applicationUsers" element={<AuthorisedRepresentativeComponent />} />,
  <Route key="6" path="applicationtype" element={<ApplicationTypePage />} />,
  <Route key="9" path="applicationchecklist" element={<ApplicationChecklistPage />} />,
  <Route key="8" path="adminNotes" element={<AdminNotesPage />} />,
  <Route key="4" path="assignstatus" element={<AssignStatusPage />} />,
  <Route key="5" path="assignassessor" element={<AssignAssessorPage />} />,
  <Route key="11" path="groupSupportNeeds" element={<GroupSupportNeedsPage />} />,
  <Route key="10" path="contextofchild" element={<ContextOfChildPage />} />,
  <Route key="applicationCreation" path="applicationCreation" element={<ApplicationCreationPage />} />,
  <Route key="12" path="supportType" element={<SupportTypePage />} />,
  <Route key="appealRequest" path="appealRequest" element={<AppealRequestPage />} />,
  <Route key="appealOutcome" path="appealOutcome" element={<AppealOutcomePage />} />,
  <Route key="contextofchildlegacy" path="contextofchildLegacy" element={<ContextOfChildComponentLegacy />} />,
  <Route key="transferRequest" path="transferRequest" element={<TransferRequestPage />} />,
];

const applicationLegacyChildren: React.ReactElement[] = [
  <Route key="1" index element={<ApplicationViewLegacy />} />,
  <Route key="2" path="applicationfiles" element={<ApplicationFilesPage />} />,
  <Route key="3" path="child" element={<ChildPageLegacy />} />,
  <Route key="4" path="assignstatus" element={<AssignStatusPage />} />,
  <Route key="appealRequest" path="appealRequest" element={<AppealRequestPageLegacy />} />,
  <Route key="5" path="assignassessor" element={<AssignAssessorPage />} />,
  <Route key="6" path="applicationtype" element={<ApplicationTypePageLegacy />} />,
  <Route key="7" path="kindergarten" element={<KindergartenPageLegacy />} />,
  <Route key="8" path="adminNotes" element={<AdminNotesPage />} />,
  <Route key="9" path="applicationchecklist" element={<ApplicationChecklistPageLegacy />} />,
  <Route key="applicationApproval" path="applicationApproval" element={<ApplicationApprovalPageLegacy />} />,
  <Route key="10" path="contextofchild" element={<ContextOfChildPageLegacy />} />,
  <Route key="11" path="groupSupportNeeds" element={<GroupSupportNeedsPage />} />,
  <Route key="supportType" path="supportType" element={<SupportTypePageLegacy />} />,

  <Route key="12" path="applicationApproval" element={<ApplicationApprovalPageLegacy />} />,
  <Route key="appealOutcome" path="appealOutcome" element={<AppealOutcomePageLegacy />} />,
  <Route key="13" path="kindergartenProgram" element={<KinderProgramPage />} />,
  <Route key="contextofchildlegacy" path="contextofchildLegacy" element={<ContextOfChildComponentLegacy />} />,
];

const providerApplicationLegacyChildren: React.ReactElement[] = [<Route key="1" index element={<ApplicationProviderViewLegacy />} />];
const providerApplicationCurrentChildren: React.ReactElement[] = [<Route key="1" index element={<ApplicationProviderView />} />];

const providerChildren: React.ReactElement[] = [
  <Route key="providerView" index element={<ProviderView />} />,
  <Route key="providerDetails" path="providerDetails" element={<ProviderDetailsPage />} />,
  <Route key="manageProviders" path=":userid" element={<ManageUserPage type="Provider" />} />,
];

const kindergartenApplicationChildren: React.ReactElement[] = [
  <Route key="kindergartenView" index element={<KindergartenApplicationView />} />,
  <Route key="screeningQuestions" path="screeningQuestions" element={<ScreeningQuestionsPage />} />,
  <Route key="child" path="child" element={<ChildPage />} />,
  <Route key="kindergarten" path="kindergarten" element={<KindergartenPage />} />,
  <Route key="supportRequested" path="supportRequested" element={<SupportRequestedPage />} />,
  <Route key="childAttendance" path="childAttendance" element={<ChildAttendancePage />} />,

  <Route key="applicationCreation" path="applicationCreation" element={<ApplicationCreationPage />} />,
  <Route key="contextofchild" path="contextofchild" element={<ContextOfChildPage />} />,
  <Route key="groupInformation" path="groupInformation" element={<GroupInformationPage />} />,
  <Route key="supportingDocuments" path="supportingDocuments" element={<SupportingDocumentsPage />} />,
  <Route key="applicationtype" path="applicationtype" element={<ApplicationTypeComponent disabled={true} />} />,
  <Route
    key="providingInclusiveKindergartenEnvironment"
    path="providingInclusiveKindergartenEnvironment"
    element={<ProvidingInclusiveKindergartenEnvironmentPage />}
  />,
  <Route key="submitapplication" path="submitapplication" element={<SubmitInitialApplicationPage />} />,
];

const applicationRoute = (childRoutes: React.ReactElement[]): React.ReactElement[] => [
  <Route
    key="applicationRoute"
    path=":id"
    element={
      <div className="p-0 h-auto flex">
        <SideNav />
        <div className="w-full">
          <ApplicationContextProvider>
            <Outlet />
          </ApplicationContextProvider>
        </div>
      </div>
    }>
    {childRoutes}
    <Route path=":userid" element={<ManageUserPage type={"Kindergarten"} />} />
  </Route>,
];

const providerApplicationRoute = (childRoutes: React.ReactElement[]): React.ReactElement[] => [
  <Route
    key="providerApplicationRoute"
    path=":id"
    element={
      <div className="p-0 h-auto flex">
        <SideNav />
        <ApplicationContextProvider>
          <Outlet />
        </ApplicationContextProvider>
      </div>
    }>
    {childRoutes}
  </Route>,
];

const internalCurrentLegacyApplications: React.ReactElement[] = [
  <Route key="legacy" path="ApplicationBaseLegacy" element={<Outlet />}>
    {applicationRoute(applicationLegacyChildren)}
  </Route>,
  <Route key="current" path="ApplicationBaseCurrent" element={<Outlet />}>
    {applicationRoute(applicationCurrentChildren)}
  </Route>,
];

const providerApplication: React.ReactElement[] = [
  <Route key="legacy" path="ApplicationBaseLegacy" element={<Outlet />}>
    {providerApplicationRoute(providerApplicationLegacyChildren)}
  </Route>,
  <Route key="current" path="ApplicationBaseCurrent" element={<Outlet />}>
    {providerApplicationRoute(providerApplicationCurrentChildren)}
  </Route>,
];

export default App;
